import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import ManagerCommBonusTable from "./Table/managerCommBonusTable";

const ManagerCommPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="managercomm_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Manager Community Bonus"
      table={<ManagerCommBonusTable />}
    />
  );
};

export default ManagerCommPage;
